import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MERCADERIA_SECADA } from '../../../../config/tables'

function LiquidacionMercaderiaSecadaView () {
  return (
    <MuiTable id={TABLA_MERCADERIA_SECADA} />
  )
}

export default LiquidacionMercaderiaSecadaView
